import { CdkDragDrop, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faAngleDown, faAngleUp, faLongArrowAltLeft, faSave, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { ConfirmSaveComponent } from 'app/component/confirm-save/confirm-save.component';
import { Menu } from 'app/shared/models/Menus/menus';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { ConfirmResetComponent } from '../confirm-reset/confirm-reset.component';

@Component({
  selector: 'app-parameter-menus',
  templateUrl: './parameter-menus.component.html',
  styleUrls: ['./parameter-menus.component.scss']
})
export class ParameterMenusComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() menu: Menu[];

  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faUndoAlt = faUndoAlt;
  faSave = faSave;
  faLongArrowAltLeft = faLongArrowAltLeft;

  // menu: Menu[];
  menuUpdate: any;
  confirm: boolean;
  dragInMove: boolean;
  newMenu: object;
  menuChangeAfterReset: Menu[];



  constructor(
    private dataService: DataService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private uiService: UiService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    // this.getMenu();

  }

  confirmChange(): void {
    this.dataService.isConfirmUpdate.next(false);
    this.menuUpdate ? this.menu = this.menuUpdate : this.menu = this.menu;

    this.userService.updateMenu(this.menu).subscribe(() => {
      this.uiService.openSnackBar('Les changements ont été enregistrés', '');
    });
    this.dataService.menu.next(this.menu);
  }

  drop(event: CdkDragDrop<object>): void {
    moveItemInArray(this.menu, event.previousIndex, event.currentIndex);
    this.dataService.isConfirmUpdate.next(true);
    // document.getElementById('confirm').style.opacity = '1';
    this.newMenu = this.menu;
    this.dataService.dragInMove.next(false);
  }

  dragInProgess(event: CdkDragStart): void {
    event ?
      this.dataService.dragInMove.next(true) :
      this.dataService.dragInMove.next(false);

    const confirm = document.getElementById('confirm');

    if (confirm !== null) {
      confirm.style.opacity = '1';
    }
  }

  cancel(): void {
    this.dataService.showBtnParamMenu.next(false);
    this.dataService.isConfirmUpdate.next(false);
    this.getMenu();
  }


  scrollToElement($element): void {
    $element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  openDialogConfirmReset(): void {
    const dialogRef = this.dialog.open(ConfirmResetComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.menu = this.menuChangeAfterReset;
      this.userService.updateMenu(this.menu).subscribe(() => {
        this.uiService.openSnackBar('Les changement ont été enregistrés', '');
      });
    });
  }

  openDialogConfirmSAve(): void {
    const dialogRef = this.dialog.open(ConfirmSaveComponent, { data: { title: 'Quitter sans sauvegarder', text: 'Êtes-vous sûr de vouloir quitter sans sauvegarder ?' } });

    dialogRef.afterClosed().subscribe(res => {
      if (res) { this.cancel(); }
    });
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.isConfirmUpdate.asObservable().subscribe(conf => {
          this.confirm = conf;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.dragInMove.asObservable().subscribe(drag => {
          this.dragInMove = drag;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.menu.asObservable().subscribe(menu => {
          this.menuChangeAfterReset = menu;
          this.cdr.detectChanges();
        })
      );

  }

}
